<template>
  <div class="match-badge" :class="rateClass">
    <span class="rate-num">{{ matchRate }}<small>%</small></span>
    <span class="rate-text">智能匹配</span>
  </div>
</template>

<script>
export default {
  name: 'MatchRateBadge',
  props: {
    matchRate: { type: Number, default: 0 }
  },
  computed: {
    rateClass() {
      if (this.matchRate >= 80) return 'tier-high';
      if (this.matchRate >= 50) return 'tier-mid';
      return 'tier-low';
    }
  }
};
</script>

<style lang="less" scoped>
.match-badge {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  height: 1.15rem;
  padding: 0 0.5rem;
  border-radius: 999px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.rate-num {
  font-size: 0.6rem;
  font-weight: 700;
  line-height: 1;

  small {
    font-size: 0.6rem;
    font-weight: 700;
    margin-left: 1px;
  }
}

.rate-text {
  font-size: 0.6rem;
  font-weight: 600;
}

/* ---- 高匹配 ≥80%: 粉色纵向渐变 ---- */
.tier-high {
  background: linear-gradient(180deg, #feb5b1, #f7e8eb);

  .rate-num, .rate-text { color: #fff; }
}

/* ---- 中匹配 50-79%: 纯玫瑰粉 ---- */
.tier-mid {
  background: #FF8A9A;

  .rate-num, .rate-text { color: #fff; }
}

/* ---- 低匹配 <50%: 浅粉底+粉字 ---- */
.tier-low {
  background: #FFF0F3;

  .rate-num { color: #FF8A9A; }
  .rate-text { color: rgba(255, 138, 154, 0.7); }
}
</style>



// WEBPACK FOOTER //
// src/components/encounter/MatchRateBadge.vue